import React, { useEffect, useMemo, useState } from "react";
import {
    Box, Typography, Chip, Button, IconButton, Grid, Menu, MenuItem, Stack, TextField, Popper, Dialog, DialogTitle, DialogContent,
    Grow, Paper, ClickAwayListener, DialogContentText, DialogActions, Checkbox, FormControlLabel, Popover
} from "@mui/material";
import { RxCross2 } from "react-icons/rx";
import TableComponent from "components/grid";
import { ReactComponent as EditIcon } from "assets/icons/EditIcon.svg";
import { useParams } from "react-router-dom";
import moment from "moment";
import { LuEye, LuRefreshCw, LuSearch } from "react-icons/lu";
import { MdOutlineFileDownload, MdOutlineFilterAlt } from "react-icons/md";
import { DEFAULT_DATE_FORMAT } from "config";
import CustomPagination from "components/CustomPagination";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useLazyGetAllProcurementBoughtItemsQuery, useDeleteProcurementBoughtItemsMutation, useLazyGetExportAllProcurementBoughtItemsQuery } from "store/slices/apis/procurementBoughtItemsSlice";
import ViewBoi from "./viewProcurement/BoiView";
import EditBoughtOutItems from "./editProcurement/BoughtItem";
import Select from "react-select";
import { useGetMasterDataQuery } from "store/slices/apis/masterConfigation";
import { usePermission } from "hooks/usePermission";
import { PROCUREMENT_EDIT, PROCUREMENT_VIEW, PROCUREMENT_DELETE } from "helpers/permissionConfig";
import { MdDeleteOutline } from "react-icons/md";
import { closeSnackbar, openSnackbar } from "store/slices/snackbar";
import { useDispatch } from "store";
import CustomButton from "components/Button";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { exportToExcel } from "utils/ExportToExcel";
import ViewColumnIcon from '@mui/icons-material/ViewColumn';


const getAvatarColor = (title) => {
    const colors = ["#1976D2", "#388E3C", "#F57C00", "#7B1FA2", "#0288D1", "#C2185B"];
    const index = title ? title.charCodeAt(0) % colors.length : 0;
    return colors[index];
};


const CustomDateCell = ({ date, historyOfDates }) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const allDates = date
        ? [...(historyOfDates || [])].filter(d => d && moment(d).isValid())
        : [];

    const lastTwoDates = allDates.slice(-2);
    const extraCount = allDates.length - lastTwoDates.length;

    const handleOpen = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    return (

        extraCount > 0 && (
            <>
                <IconButton size="small" onClick={handleOpen}>
                    <MoreHorizIcon fontSize="small" />
                </IconButton>

                <Popover
                    open={Boolean(anchorEl)}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                >
                    <Box sx={{ p: 1, gap: 0.5, flexWrap: "wrap" }}>
                        {[
                            ...new Set(allDates || [])
                        ]
                            .slice(0, -2)
                            .map((date, i) => (
                                <Box key={i} sx={{ width: "100%", m: 1 }}>
                                    <Chip
                                        label={moment(date).format(DEFAULT_DATE_FORMAT)}
                                        sx={{
                                            textDecoration: "line-through",
                                            color: "#e51c1cff",
                                            backgroundColor: "#f5ccccff",
                                            fontWeight: 500,
                                            height: "20px",
                                            borderRadius: "3px",
                                            padding: "2px 6px",
                                            fontFamily: "Outfit",
                                            fontSize: "12px",
                                            marginRight: "5px",
                                        }}
                                    />
                                </Box>
                            ))}

                    </Box>
                </Popover>
            </>
        )
    );
};


const calenderSVG = (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_894_610)">
            <path d="M12.6667 1.33333H12V0.666667C12 0.489856 11.9298 0.320286 11.8047 0.195262C11.6797 0.0702379 11.5101 0 11.3333 0C11.1565 0 10.987 0.0702379 10.8619 0.195262C10.7369 0.320286 10.6667 0.489856 10.6667 0.666667V1.33333H5.33333V0.666667C5.33333 0.489856 5.2631 0.320286 5.13807 0.195262C5.01305 0.0702379 4.84348 0 4.66667 0C4.48986 0 4.32029 0.0702379 4.19526 0.195262C4.07024 0.320286 4 0.489856 4 0.666667V1.33333H3.33333C2.4496 1.33439 1.60237 1.68592 0.97748 2.31081C0.352588 2.93571 0.00105857 3.78294 0 4.66667L0 12.6667C0.00105857 13.5504 0.352588 14.3976 0.97748 15.0225C1.60237 15.6474 2.4496 15.9989 3.33333 16H12.6667C13.5504 15.9989 14.3976 15.6474 15.0225 15.0225C15.6474 14.3976 15.9989 13.5504 16 12.6667V4.66667C15.9989 3.78294 15.6474 2.93571 15.0225 2.31081C14.3976 1.68592 13.5504 1.33439 12.6667 1.33333ZM1.33333 4.66667C1.33333 4.13623 1.54405 3.62753 1.91912 3.25245C2.29419 2.87738 2.8029 2.66667 3.33333 2.66667H12.6667C13.1971 2.66667 13.7058 2.87738 14.0809 3.25245C14.456 3.62753 14.6667 4.13623 14.6667 4.66667V5.33333H1.33333V4.66667ZM12.6667 14.6667H3.33333C2.8029 14.6667 2.29419 14.456 1.91912 14.0809C1.54405 13.7058 1.33333 13.1971 1.33333 12.6667V6.66667H14.6667V12.6667C14.6667 13.1971 14.456 13.7058 14.0809 14.0809C13.7058 14.456 13.1971 14.6667 12.6667 14.6667Z" fill="#433F5E" />
            <path d="M8 11C8.55228 11 9 10.5523 9 10C9 9.44772 8.55228 9 8 9C7.44772 9 7 9.44772 7 10C7 10.5523 7.44772 11 8 11Z" fill="#433F5E" />
            <path d="M4.66656 11C5.21885 11 5.66656 10.5523 5.66656 10C5.66656 9.44772 5.21885 9 4.66656 9C4.11428 9 3.66656 9.44772 3.66656 10C3.66656 10.5523 4.11428 11 4.66656 11Z" fill="#433F5E" />
            <path d="M11.3334 11C11.8857 11 12.3334 10.5523 12.3334 10C12.3334 9.44772 11.8857 9 11.3334 9C10.7811 9 10.3334 9.44772 10.3334 10C10.3334 10.5523 10.7811 11 11.3334 11Z" fill="#433F5E" />
        </g>
        <defs>
            <clipPath id="clip0_894_610">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
);



const HotelBOIList = (props) => {
    const { canceltabValue, tabLength } = props
    const dispatch = useDispatch()
    const [menuAnchorEl, setMenuAnchorEl] = useState(null);
    const [menuRow, setMenuRow] = useState(null);
    const [open, setOpen] = React.useState(false);
    const { projectId } = useParams();
    const [isDeleteModal, setDeleteModal] = useState(false);
    const [procurementDeleteFn, procurementDeleteRes] = useDeleteProcurementBoughtItemsMutation();

    const editAccess = usePermission(PROCUREMENT_EDIT);
    const viewAccess = usePermission(PROCUREMENT_VIEW);
    const deleteAccess = usePermission(PROCUREMENT_DELETE);

    const isAdmin = usePermission()

    const module = "Procurement"

    // sorting asc desc
    const [sortOrder, setSortOrder] = React.useState('desc');
    const [sortBy, setSortBy] = React.useState('createdDate');

    // page size
    const [pageNumber, setPageNumber] = React.useState(1);
    const [pageSize, setPageSize] = React.useState(10);

    // page size
    const [isApplyFilter, setIsApplyFIlter] = React.useState(false);

    const [loading, setLoading] = useState(false);
    const [tabValue, setTabValue] = useState(0);
    const anchorRef = React.useRef(null);
    const [isAdd, setIsAdd] = useState(false);
    const [selectedIndex, setSelectedIndex] = React.useState(1);

    const [isEditTracker, setIsEditTracker] = useState(false);
    const [isViewTracker, setIsViewTracker] = useState(false);
    const [rowData, setRowData] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [columnAnchor, setColumnAnchor] = useState(null);
    const [tableColumns, setTableColumns] = useState([]);
    const [visibleColumns, setVisibleColumns] = useState([]);

    const handleColumnOpen = (e) => setColumnAnchor(e.currentTarget);
    const handleColumnClose = () => setColumnAnchor(null);

    const handleDeleteProcurementTracker = () => {
        if (isDeleteModal) {
            handleMenuClose();
        }
        setDeleteModal((prev) => !prev);
    }

    const handleConfirmationDelete = () => {
        procurementDeleteFn(menuRow?.procurementBOItemId)
    }

    const openNotification = (msg, type = "error", duration = 3000) => {
        dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: {
                    color: type
                },
                close: false
            })
        );
        setTimeout(() => dispatch(closeSnackbar()), duration);
    };

    const confirmationDeleteDialog = () => (
        <Dialog
            open={isDeleteModal}
            fullWidth
            maxWidth="md"
            PaperProps={{
                sx: { borderTopLeftRadius: "5px", borderTopRightRadius: "5px", backgroundColor: "#FFFFFF", width: "100%", overflowX: "hidden" },
            }}
            disableEscapeKeyDown
            onClose={(event, reason) => {
                if (reason !== "backdropClick") {
                    // handleClose();
                }
            }}
        >
            <DialogTitle sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderBottom: "1px solid #ddd",
                backgroundColor: "#ECECEC",
                pb: 2,
                pt: 3,
                width: "100%",
            }}><Typography sx={{ fontWeight: 600, fontSize: "27px", lineHeight: "100%", color: "#140F36", fontFamily: "Outfit, sans-serif" }}>
                    Delete Procurement Plan -  Bought Out Items
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={() => handleDeleteProcurementTracker()}
                    sx={(theme) => ({
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    {/* <IoMdClose style={{ fontSize: "20px" }} /> */}
                    <RxCross2 style={{ fontSize: "30px", color: "#140F36" }} />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{ padding: '24px !important' }}>
                <DialogContentText sx={{ fontWeight: 400, fontSize: '16px', color: '#474747', fontFamily: "Outfit, sans-serif" }}>
                    Are you sure you want to Delete this Procurement tracker ? This action is permanent.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <CustomButton
                    label="Delete"
                    startIcon={<MdDeleteOutline />}
                    onClick={handleConfirmationDelete}
                    loading={procurementDeleteRes?.isLoading}
                    sx={{
                        backgroundColor: "#00344C",
                        fontFamily: 'Outfit',
                        fontWeight: 500,
                        fontSize: '14px',
                        lineHeight: '100%',
                        letterSpacing: '0px',
                    }}
                />
            </DialogActions>
        </Dialog>
    );

    React.useEffect(() => {
        if (procurementDeleteRes?.isSuccess) {
            if (procurementDeleteRes?.data?.status?.toLowerCase() == 'success') {
                openNotification(procurementDeleteRes?.data?.message, 'success')
                handleDeleteProcurementTracker();
            } else {
                openNotification(procurementDeleteRes?.data?.message, 'error')
            }
        }
    }, [procurementDeleteRes?.isSuccess]);


    // React.useEffect(() => {
    //     if (procurementDeleteRes?.isError) {
    //         if (procurementDeleteRes?.error?.data?.status?.toLowerCase() == 'error') {
    //             openNotification(procurementDeleteRes?.error?.data?.message, 'error')
    //         } else {
    //             openNotification(procurementDeleteRes?.error?.data?.message ?? 'Something went wrong!', 'error')
    //         }
    //         handleDeleteProcurementTracker();
    //     }
    // }, [procurementDeleteRes?.isError]);

    React.useEffect(() => {
        if (procurementDeleteRes?.isError) {
            const errorData = procurementDeleteRes?.error?.data;
            const statusVal = String(errorData?.status || "").toLowerCase();
            const errorMessage = errorData?.message || "Something went wrong on the server!";
            openNotification(errorMessage, 'error');
            handleDeleteProcurementTracker();
        }
    }, [procurementDeleteRes?.isError]);

    const getStatusByTab = (tabValue) => {
        switch (true) {
            case (tabValue === tabLength):
                return true;
            default:
                return false;
        }
    };

    const [filters, setFilters] = useState({
        ProjectId: projectId,
        SortBy: sortBy,
        SortOrder: sortOrder,
        PageNumber: pageNumber,
        PageSize: pageSize,
        IsCancel: getStatusByTab(canceltabValue)

    });
    const [actionContact, setActionContact] = useState([]);
    const [trigger, { data: BoitemData, isLoading, isFetching }] = useLazyGetAllProcurementBoughtItemsQuery()

    const { data: vendorNameList } = useGetMasterDataQuery({ module: module, category: 'VendorName', ProjectId: projectId });

    const vendorNameOption = useMemo(() => {
        return vendorNameList?.data
            ?.map((item) => ({
                label: item?.value,
                value: item?.value
            }))
            ?.sort((a, b) => a?.label?.localeCompare(b?.label)) || [];
    }, [vendorNameList]);

    const { data: procurementStatusRes } = useGetMasterDataQuery({ module: module, category: 'Status', ProjectId: projectId });
    const procurementStatusData = procurementStatusRes?.data || [];
    const procurementStatusOption = (procurementStatusData || []).map(p => ({
        value: p?.value,
        label: p?.value,
    }));

    const handlePageChange = (newPage) => {
        setPageNumber(newPage);
        const updatedFilters = {
            ...filters,
            PageNumber: newPage,
        };
        setFilters(updatedFilters);
        trigger(updatedFilters);
    };

    const handleCheckboxChange = (event) => {

        const updatedFilters = {
            ...filters,
            LongLead: event.target.checked,
        };
        setFilters(updatedFilters);

    };


    const handlePageSizeChange = (newSize) => {
        setPageSize(newSize);
        setPageNumber(1);
        const updatedFilters = {
            ...filters,
            PageSize: newSize,
            PageNumber: 1,
        };
        setFilters(updatedFilters);
        trigger(updatedFilters);
    };

    useEffect(() => {
        setFilters((prev) => ({
            ...prev,
            IsCancel: getStatusByTab(canceltabValue)
        }));
    }, [canceltabValue]);


    useEffect(() => {
        trigger(filters);
    }, []);


    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            if (searchTerm !== filters.SearchTerm) {
                const updatedFilters = {
                    ...filters,
                    SearchTerm: searchTerm,
                    PageNumber: 1,
                };
                setFilters(updatedFilters);
                trigger(updatedFilters);
                setPageNumber(1);
            }
        }, 500);
        return () => clearTimeout(delayDebounceFn);
    }, [searchTerm]);


    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };



    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };


    const handleClose = () => {
        setOpen(false);
    };

    const handleDelete = (filterType) => {
        const updatedFilters = {
            ...filters,
            [filterType]: "",
            IsCancel: getStatusByTab(canceltabValue),
            PageNumber: 1
        };

        setFilters(updatedFilters);
        trigger(updatedFilters);
        setTabValue(0)
        setPageNumber(1);
    };


    const handleApplyFilters = () => {
        const updatedFilters = {
            ...filters,
            PageNumber: 1,
        };

        setFilters(updatedFilters);
        trigger(updatedFilters);
        setPageNumber(1);
        handleClose();
    };


    const handleReset = () => {
        const resetFilters = {
            ProjectId: projectId,
            SortBy: sortBy,
            SortOrder: sortOrder,
            PageNumber: 1,
            PageSize: 10,
            IsCancel: getStatusByTab(canceltabValue)
        };
        setFilters(resetFilters);
        trigger(resetFilters);
        setPageNumber(1);
        handleClose();
    };


    const handleSelectChange = (selectedOption, fieldName) => {
        const updatedFilters = {
            ...filters,
            [fieldName]: selectedOption?.value || "",
            PageNumber: 1,
        };

        setFilters(updatedFilters);
        // trigger(updatedFilters);
        // setPageNumber(1);
    };


    const handleDateChange = (e) => {
        const { name, value } = e.target;

        let utcDate = "";
        if (value) {

            const localDate = new Date(value);
            utcDate = localDate.toISOString();
        }

        const updatedFilters = {
            ...filters,
            [name]: utcDate,
            PageNumber: 1,
        };

        setFilters(updatedFilters);
        // trigger(updatedFilters);
        // setPageNumber(1);
    };

    const handleRequestSort = (property) => {
        const isAsc = sortBy === property && sortOrder === 'asc';
        const updatedFilters = {
            ...filters,
            SortBy: property,
            SortOrder: isAsc ? 'desc' : 'asc'

        };
        setFilters(updatedFilters);
        setSortOrder(isAsc ? 'desc' : 'asc');
        setSortBy(property);
        trigger(updatedFilters);

    };

    const handleMenuOpen = (event, row) => {
        event.stopPropagation(); // prevent row click if any
        setMenuAnchorEl(event.currentTarget);
        setMenuRow(row);
    };

    const handleMenuClose = () => {
        setMenuAnchorEl(null);
        setMenuRow(null);
    };

    const handleMenuEdit = () => {
        if (menuRow) {
            handleEditTracker(menuRow);
        }
        handleMenuClose();
    };

    const handleMenuView = () => {
        if (menuRow) {
            handleViewClick(menuRow);
        }
        handleMenuClose();
    };

    const [triggerExport, { isFetching: isExporting }] = useLazyGetExportAllProcurementBoughtItemsQuery();


    const handleExportExcel = async () => {
        try {
            const exportFilters = {
                ...filters,
                PageNumber: 1,
                PageSize: 5000,
            };

            const response = await triggerExport(exportFilters).unwrap();
            const rows = response?.data || [];

            if (!Array.isArray(rows) || rows.length === 0) {
                openNotification("No data available to export", "warning");
                return;
            }


            const isDateField = (field) => {
                const dateKeywords = ['Date', 'Due', 'Created', 'Updated', 'Revised', 'Planned', 'Actual', 'Release', 'Start', 'Finish', 'Requisition', 'PO Date'];
                return dateKeywords.some(kw => field.includes(kw));
            };


            const isNumberField = (field) => {
                const numberFields = ['budgetedCost', 'actualCost', 'poValue', 'mobilizationRequiredDaysLeft', 'leadTime', 'quantityRequired', 'processTime', 'poNumber',
                    'poQuantity', 'poRate', 'deliveredQty', 'pendingQty', 'budgetedUnitRate', 'actualUnitRate'];
                return numberFields.includes(field);
            };


            const formattedData = rows.map((row, index) => {
                const rowData = { "S.No": index + 1 };

                columns.forEach(col => {
                    const field = col.field;
                    let value = '-';

                    if (field && row[field] !== undefined && row[field] !== null) {
                        const raw = row[field];

                        if (isDateField(field) && moment(raw).isValid()) {
                            value = moment(raw).format(DEFAULT_DATE_FORMAT);
                        }

                        else if (isNumberField(field) && !isNaN(parseFloat(raw))) {
                            value = Number(raw).toLocaleString("en-IN", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                            });
                        }

                        else {
                            value = raw;
                        }
                    }

                    rowData[col.name] = value;
                });

                return rowData;
            });

            exportToExcel(formattedData, "Procurement_Bought-Out_Item_Data");
            openNotification("Excel exported successfully", "success");
        } catch (error) {
            console.error("Export error:", error);
            openNotification("Failed to export Excel", "error");
        }
    };


    const columns = [
        {
            name: "",
            field: "actions",
            width: "10px",
            sticky: true,
            renderer: (row) => (
                <>
                    {(viewAccess || editAccess || deleteAccess) &&
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <IconButton
                                size="small"
                                onClick={(e) => handleMenuOpen(e, row)}
                            >
                                <MoreVertIcon fontSize="small" />
                            </IconButton>
                        </Box>
                    }
                </>
            ),
        },
        {
            name: "ID",
            field: "customId",
            width: "100px",
            sticky: true
        },
        {
            name: "Material Description",
            field: "materialDescription",
            width: "300px",
            renderer: (row) => highlightText(row.materialDescription, searchTerm),
        },

        {
            name: "Budgeted Cost",
            field: "budgetedCost",
            renderer: (row) => (
                <>
                    {row?.budgetedCost !== null && row?.budgetedCost !== undefined
                        ? Number(row.budgetedCost).toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        })
                        : '-'}
                </>
            ),
        },
        {
            name: "Vendor Name",
            field: "vendorName",
            sticky: true,
            width: "150px",
            renderer: (row) => (
                <>
                    {row?.vendorName ? row?.vendorName : '-'}
                </>
            ),
        },
        {
            name: "Actual Cost",
            field: "actualCost",
            renderer: (row) => (

                <>
                    {row?.actualCost !== null && row?.actualCost !== undefined
                        ? Number(row.actualCost).toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        })
                        : '-'}
                </>

            ),
        },
        {
            name: "Procurement Owner",
            field: "procurementOwner",
            renderer: (row) => (
                <>
                    {row?.procurementOwner ? row?.procurementOwner : '-'}
                </>
            ),
        },

        {
            name: "Sub Project",
            field: "subProject",
            sticky: true,
            width: "150px",
            renderer: (row) => highlightText(row.subProject, searchTerm),
        },

        {
            name: "Material Procurement Status",
            field: "materialProcurementStatus",
            width: "200px",
            // sticky: true,
            renderer: (row) => (
                <>
                    {row?.materialProcurementStatus ? row?.materialProcurementStatus : '-'}
                </>
            ),
        },

        {
            name: "Material Category",
            field: "materialCategory",
            renderer: (row) => (
                <>
                    {row?.materialCategory ? row?.materialCategory : '-'}
                </>
            ),
        },
        {
            name: "UOM",
            field: "uom",
            renderer: (row) => (
                <>
                    {row?.uom ? row?.uom : '-'}
                </>
            ),
        },
        {
            name: "Quantity Required",
            field: "quantityRequired",
            renderer: (row) => (
                <>
                    {row?.quantityRequired ? row?.quantityRequired : '-'}
                </>
            ),
        },
        {
            name: "Lead Time",
            field: "leadTimeDays",
            renderer: (row) => (
                <>
                    {row?.leadTimeDays ? row?.leadTimeDays : '-'}
                </>
            ),
        },
        {
            name: "Procurement Method",
            field: "procurementMethod",
            renderer: (row) => (
                <>
                    {row?.procurementMethod ? row?.procurementMethod : '-'}
                </>
            ),
        },
        {
            name: "Source Department",
            field: "sourceDepartment",
            renderer: (row) => (
                <>
                    {row?.sourceDepartment ? row?.sourceDepartment : '-'}
                </>
            ),
        },


        {
            name: "Budgeted Unit Rate",
            field: "budgetedUnitRate",
            renderer: (row) => (
                <>
                    {row?.budgetedUnitRate ? row?.budgetedUnitRate : '-'}
                </>
            ),
        },
        {
            name: "Actual Unit Rate",
            field: "actualUnitRate",
            renderer: (row) => (
                <>
                    {row?.actualUnitRate ? row?.actualUnitRate : '-'}
                </>
            ),
        },
        {
            name: "Requisition Date",
            field: "requisitionDate",
            renderer: (row) => (
                <>
                    {row?.requisitionDate ? moment(row.requisitionDate).format("DD MMM YYYY") : '-'}
                </>
            ),
        },
        {
            name: "Planned Date Of Release Of LOI/WO/PO",
            field: "plannedLoiWoPoReleaseDate",
            renderer: (row) => (
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                    {
                        row?.planLoiWoPoReleaseDateHistory?.length >= 2 ?
                            <>
                                <CustomDateCell date={row.plannedLoiWoPoReleaseDate} historyOfDates={row.planLoiWoPoReleaseDateHistory} />
                                {[...(row?.planLoiWoPoReleaseDateHistory || [])]?.filter(val => val && moment(val).isValid()).slice(-2)?.map((val, ind, arr) => {
                                    const isLast = ind === arr.length - 1;

                                    return (
                                        <Chip
                                            key={ind}
                                            label={moment(val).format(DEFAULT_DATE_FORMAT)}
                                            sx={{
                                                textDecoration: isLast ? "none" : "line-through",
                                                color: isLast ? "#34A853" : "#e51c1cff",
                                                backgroundColor: isLast ? "#E1FFBB" : "#f5ccccff",
                                                fontWeight: 500,
                                                height: "20px",
                                                borderRadius: "3px",
                                                padding: "2px 6px",
                                                fontFamily: "Outfit",
                                                fontSize: "12px",
                                                marginRight: "5px",
                                            }}
                                        />
                                    );
                                })}
                            </>
                            :
                            <>
                                {moment(row?.plannedLoiWoPoReleaseDate).isValid() ?
                                    <Chip
                                        label={moment(row?.plannedLoiWoPoReleaseDate).format(DEFAULT_DATE_FORMAT)}
                                        sx={{
                                            // textDecoration: "line-through",
                                            color: "#34A853",
                                            // color: getStatusColor(row).text,
                                            backgroundColor: "#E1FFBB",
                                            fontWeight: 500,
                                            height: "20px",
                                            borderRadius: "3px",
                                            padding: "2px 6px",
                                            fontFamily: "Outfit",
                                            fontSize: "12px",
                                            marginRight: "5px",
                                        }}
                                    />
                                    : '-'
                                }
                            </>
                    }
                </Box>
            ),
        },
        {
            name: "PO Date",
            field: "poDate",
            renderer: (row) => (
                <>
                    {row?.poDate ? moment(row.poDate).format("DD MMM YYYY") : '-'}
                </>
            ),
        },
        {
            name: "PO Number",
            field: "poNumber",
            renderer: (row) => (
                <>
                    {row?.poNumber ? row?.poNumber : '-'}
                </>
            ),
        },
        {
            name: "PO Quanity",
            field: "poQuantity",
            renderer: (row) => (
                <>
                    {row?.poQuantity ? Number(row.poQuantity).toFixed(2) : '-'}
                </>
            ),
        },
        {
            name: "PO Rate",
            field: "poRate",
            renderer: (row) => (
                <>
                    {row?.poRate ? Number(row.poRate).toFixed(2) : '-'}
                </>
            ),
        },
        {
            name: "PO Value (In INR)",
            field: "poValue",
            renderer: (row) => (
                <>
                    {row?.poValue ? row?.poValue : '-'}
                </>
            ),
        },
        {
            name: "Planned Delivery Date",
            field: "plannedDeliveryDate",
            renderer: (row) => (
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                    {
                        row?.plannedDeliveryDateHistory?.length >= 2 ?
                            <>
                                <CustomDateCell date={row.plannedDeliveryDate} historyOfDates={row.plannedDeliveryDateHistory} />
                                {[...(row?.plannedDeliveryDateHistory || [])]?.filter(val => val && moment(val).isValid()).slice(-2)?.map((val, ind, arr) => {
                                    const isLast = ind === arr.length - 1;

                                    return (
                                        <Chip
                                            key={ind}
                                            label={moment(val).format(DEFAULT_DATE_FORMAT)}
                                            sx={{
                                                textDecoration: isLast ? "none" : "line-through",
                                                color: isLast ? "#34A853" : "#e51c1cff",
                                                backgroundColor: isLast ? "#E1FFBB" : "#f5ccccff",
                                                fontWeight: 500,
                                                height: "20px",
                                                borderRadius: "3px",
                                                padding: "2px 6px",
                                                fontFamily: "Outfit",
                                                fontSize: "12px",
                                                marginRight: "5px",
                                            }}
                                        />
                                    );
                                })}
                            </>
                            :
                            <>
                                {moment(row?.plannedDeliveryDate).isValid() ?
                                    <Chip
                                        label={moment(row?.plannedDeliveryDate).format(DEFAULT_DATE_FORMAT)}
                                        sx={{
                                            // textDecoration: "line-through",
                                            color: "#34A853",
                                            // color: getStatusColor(row).text,
                                            backgroundColor: "#E1FFBB",
                                            fontWeight: 500,
                                            height: "20px",
                                            borderRadius: "3px",
                                            padding: "2px 6px",
                                            fontFamily: "Outfit",
                                            fontSize: "12px",
                                            marginRight: "5px",
                                        }}
                                    />
                                    : '-'
                                }
                            </>
                    }
                </Box>

            ),
        },
        {
            name: "Actual Delivery Date",
            field: "actualDeliveryDate",
            renderer: (row) => (
                <>
                    {row?.actualDeliveryDate ? moment(row.actualDeliveryDate).format("DD MMM YYYY") : '-'}
                </>
            ),
        },
        {
            name: "Delivered Qty",
            field: "deliveredQty",
            renderer: (row) => (
                <>
                    {row?.deliveredQty ? row?.deliveredQty : '-'}
                </>
            ),
        },
        {
            name: "Pending Qty",
            field: "pendingQty",
            renderer: (row) => (
                <>
                    {row?.pendingQty ? row?.pendingQty : '-'}
                </>
            ),
        },
        {
            name: "Delivery Variance",
            field: "deliveryVariance",
            renderer: (row) => (
                <>
                    {row?.deliveryVariance ? row?.deliveryVariance : '-'}
                </>
            ),
        },
        {
            name: "Remarks / Notes",
            field: "remarks",
            width: "300px",
            renderer: (row) => (
                <>
                    {row?.remark ? row?.remark : '-'}
                </>
            ),
        },

    ];

    useEffect(() => {
        const allColumns = columns;
        setTableColumns(allColumns);
        setVisibleColumns(allColumns.map(col => col.field));
    }, [searchTerm]);

    const handleEditTracker = (row) => {
        setIsEditTracker((prev) => {
            const newState = !prev;
            setRowData(newState ? row : null);
            return newState;
        });
    }

    const handleViewClick = (row) => {
        setIsViewTracker((prev) => {
            const newState = !prev;
            setRowData(newState ? row : null);
            return newState;
        });
    }

    const highlightText = (text, highlight) => {
        if (!highlight || !text) return text;

        const regex = new RegExp(`(${highlight})`, 'gi');
        const parts = String(text).split(regex);

        return parts.map((part, index) =>
            regex.test(part) ? (
                <span
                    key={index}
                    style={{
                        backgroundColor: '#FFF3CD',
                        color: '#856404',
                        fontWeight: 'bold',
                        padding: '0 2px',
                        borderRadius: '3px'
                    }}
                >
                    {part}
                </span>
            ) : part
        );
    };



    return (
        <>
            {confirmationDeleteDialog()}
            <Grid container spacing={2} sx={{ mt: '20px', p: 2 }}>
                <Grid size={12}>
                    <Grid container>
                        <Grid size={{ md: 8, sm: 12 }}>
                            <Stack
                                direction="row"
                                spacing={1}
                                flexWrap="wrap"
                                sx={{
                                    padding: "8px 0",
                                    alignItems: "center",
                                    minHeight: "40px"
                                }}
                            >


                                {filters.VendorName && (
                                    <Chip
                                        label={
                                            <Typography variant="body2">
                                                <strong style={{ color: '#0E73F6' }}>Vendor Name:</strong>{" "}
                                                <span style={{ fontWeight: 400, color: "#6B7280" }}>
                                                    {filters.VendorName}
                                                </span>
                                            </Typography>
                                        }
                                        sx={{
                                            backgroundColor: "rgba(25, 118, 210, 0.08)",
                                            border: 0
                                        }}
                                        variant="outlined"
                                        onDelete={() => handleDelete('VendorName')}
                                    />
                                )}
                                {filters.LongLead === true && (
                                    <Chip
                                        label={
                                            <Typography variant="body2">
                                                <strong style={{ color: '#0E73F6' }}>Long Lead:</strong>{" "}
                                                <span style={{ fontWeight: 400, color: "#6B7280" }}>
                                                    True
                                                </span>
                                            </Typography>
                                        }
                                        sx={{
                                            backgroundColor: "rgba(25, 118, 210, 0.08)",
                                            border: 0
                                        }}
                                        variant="outlined"
                                        onDelete={() => handleDelete('LongLead')}
                                    />
                                )}


                                {filters.Status && (
                                    <Chip
                                        label={
                                            <Typography variant="body2">
                                                <strong style={{ color: '#0E73F6' }}>Status:</strong>{" "}
                                                <span style={{ fontWeight: 400, color: "#6B7280" }}>
                                                    {filters.Status}
                                                </span>
                                            </Typography>
                                        }
                                        sx={{
                                            backgroundColor: "rgba(25, 118, 210, 0.08)",
                                            border: 0
                                        }}
                                        variant="outlined"
                                        onDelete={() => handleDelete('Status')}
                                    />
                                )}


                                {filters.RequisitionDate && (
                                    <Chip
                                        label={
                                            <Typography variant="body2">
                                                <strong style={{ color: '#0E73F6' }}>RequisitionDate:</strong>{" "}
                                                <span style={{ fontWeight: 400, color: "#6B7280" }}>
                                                    {moment(filters.RequisitionDate).format('DD-MM-YYYY')}
                                                </span>
                                            </Typography>
                                        }
                                        sx={{
                                            backgroundColor: "rgba(25, 118, 210, 0.08)",
                                            border: 0
                                        }}
                                        variant="outlined"
                                        onDelete={() => handleDelete('RequisitionDate')}
                                    />
                                )}
                                {filters.PoDate && (
                                    <Chip
                                        label={
                                            <Typography variant="body2">
                                                <strong style={{ color: '#0E73F6' }}>PoDate :</strong>{" "}
                                                <span style={{ fontWeight: 400, color: "#6B7280" }}>
                                                    {moment(filters.PoDate).format('DD-MM-YYYY')}
                                                </span>
                                            </Typography>
                                        }
                                        sx={{
                                            backgroundColor: "rgba(25, 118, 210, 0.08)",
                                            border: 0
                                        }}
                                        variant="outlined"
                                        onDelete={() => handleDelete('PoDate')}
                                    />
                                )}



                            </Stack>
                        </Grid>


                        <Grid size={{ md: 4, sm: 12 }}>
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: { md: "row", xs: "column" },
                                    alignItems: { md: "center", xs: "flex-start" },
                                    justifyContent: 'end',
                                    p: "8px 0px"
                                }}
                            >
                                <TextField
                                    placeholder="Search By Subproject, Material Desc"
                                    value={searchTerm}
                                    // width="100%"
                                    onChange={handleSearchChange}
                                    variant="outlined"
                                    size="small"
                                    InputProps={{
                                        startAdornment: <LuSearch style={{ marginRight: '8px', color: '#6B7280' }} />,
                                    }}
                                    sx={{
                                        minWidth: { md: '380px', xs: "auto" },
                                        // width: "100%",
                                        backgroundColor: '#fff',
                                        '& .MuiOutlinedInput-root': { borderRadius: '3px', minHeight: '36px', fontSize: '13px' },
                                        '& .MuiInputBase-input::placeholder': {
                                            fontSize: '0.9rem',
                                        }
                                    }}
                                    type="search"
                                />
                                <IconButton
                                    ref={anchorRef}
                                    onClick={handleToggle}
                                >
                                    <MdOutlineFilterAlt size={24} color="#48535B" />
                                </IconButton>
                                <Popover
                                    open={Boolean(columnAnchor)}
                                    anchorEl={columnAnchor}
                                    onClose={handleColumnClose}
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                >
                                    <Box sx={{ p: 2, width: 300 }}>
                                        <Typography sx={{ fontWeight: 600, mb: 1 }}>
                                            Select Columns
                                        </Typography>
                                        {tableColumns.map((col) => (
                                            <Box key={col.field} sx={{ display: "flex", alignItems: "center" }}>
                                                <Checkbox
                                                    checked={visibleColumns.includes(col.field)}
                                                    onChange={(e) => {
                                                        if (e.target.checked) {
                                                            setVisibleColumns(prev => [...prev, col.field]);
                                                        } else {
                                                            setVisibleColumns(prev => prev.filter(f => f !== col.field));
                                                        }
                                                    }}
                                                />
                                                <Typography sx={{ fontSize: 13 }}>
                                                    {col.name}
                                                </Typography>
                                            </Box>
                                        ))}
                                    </Box>
                                </Popover>


                                <Popper
                                    open={open}
                                    anchorEl={anchorRef.current}
                                    placement="bottom-end"
                                    transition
                                    disablePortal={false}
                                    sx={{ zIndex: 2000 }}
                                >
                                    {({ TransitionProps }) => (
                                        <Grow {...TransitionProps}>
                                            <Paper
                                                sx={{
                                                    mt: 1,
                                                    p: 2,
                                                    borderRadius: 1,
                                                    boxShadow: "0px 4px 20px rgba(7, 7, 7, 0.08)",
                                                    width: 600,
                                                }}
                                            >
                                                <ClickAwayListener onClickAway={handleClose}>
                                                    <Box>
                                                        <Grid container spacing={2}>


                                                            {!(isAdmin && canceltabValue === tabLength) && (
                                                                <Grid size={6}>
                                                                    <Typography
                                                                        sx={{
                                                                            fontFamily: 'Outfit',
                                                                            fontWeight: 500,
                                                                            fontSize: '16px',
                                                                            lineHeight: '100%',
                                                                            letterSpacing: "0px",
                                                                            mb: 1
                                                                        }}
                                                                    >
                                                                        Select Status
                                                                    </Typography>

                                                                    <Select
                                                                        name="Status"
                                                                        options={procurementStatusOption}
                                                                        placeholder="Select Status"
                                                                        onChange={(option) => handleSelectChange(option, "Status")}
                                                                        value={
                                                                            procurementStatusOption.find(
                                                                                option => option.value === filters.Status
                                                                            ) || null
                                                                        }
                                                                    />
                                                                </Grid>
                                                            )}


                                                            <Grid size={6}>
                                                                <Typography sx={{
                                                                    fontFamily: 'Outfit',
                                                                    fontWeight: 500,
                                                                    fontSize: '16px',
                                                                    lineHeight: '100%',
                                                                    letterSpacing: "0px",
                                                                    mb: 1
                                                                }}>Select Vendor Name</Typography>
                                                                <Select
                                                                    name="VendorName"
                                                                    options={vendorNameOption}
                                                                    placeholder="Select Vendor Name"
                                                                    onChange={(option) => handleSelectChange(option, "VendorName")}
                                                                    value={vendorNameOption.find(option => option.value === filters.VendorName) || null}
                                                                />
                                                            </Grid>
                                                            <Grid size={6}>
                                                                <Typography sx={{
                                                                    fontFamily: 'Outfit',
                                                                    fontWeight: 500,
                                                                    fontSize: '16px',
                                                                    mb: 1
                                                                }}>
                                                                    Long Lead
                                                                </Typography>

                                                                <FormControlLabel
                                                                    control={
                                                                        <Checkbox
                                                                            checked={filters.LongLead}
                                                                            onChange={handleCheckboxChange}
                                                                        />
                                                                    }
                                                                    label="Is Long Lead"
                                                                />
                                                            </Grid>

                                                            <Grid size={6}>
                                                                <Typography sx={{
                                                                    fontFamily: 'Outfit',
                                                                    fontWeight: 500,
                                                                    fontSize: '16px',
                                                                    lineHeight: '100%',
                                                                    letterSpacing: "0px",
                                                                    mb: 1
                                                                }}>Requisition Date</Typography>
                                                                <TextField
                                                                    type="date"
                                                                    name="RequisitionDate"
                                                                    value={filters.RequisitionDate ? new Date(filters.RequisitionDate).toISOString().split('T')[0] : ""}
                                                                    // onBlur={handleBlur}
                                                                    onChange={handleDateChange}
                                                                    onClick={(e) => {
                                                                        // Trigger the native date picker
                                                                        const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                                                                        if (input) input.showPicker?.();
                                                                    }}
                                                                    fullWidth
                                                                    sx={{
                                                                        // ...rightTextStyle,
                                                                        "& input::-webkit-calendar-picker-indicator": {
                                                                            display: "none",
                                                                            WebkitAppearance: "none",
                                                                        },
                                                                        "& input[type='date']": {
                                                                            appearance: "none",
                                                                            WebkitAppearance: "none",
                                                                        },
                                                                        "& .MuiOutlinedInput-root": {
                                                                            "& fieldset": {
                                                                                border: "none",
                                                                            },
                                                                        },
                                                                    }}
                                                                    InputProps={{
                                                                        startAdornment: (
                                                                            <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}

                                                                            >
                                                                                {calenderSVG}
                                                                            </Box>
                                                                        ),
                                                                        sx: {
                                                                            backgroundColor: "#E7E7EB",
                                                                            height: "40px",
                                                                            width: { xs: "100%", md: "100%" },
                                                                            borderRadius: "3px",
                                                                        },
                                                                    }}
                                                                />
                                                            </Grid>
                                                            <Grid size={6}>
                                                                <Typography sx={{
                                                                    fontFamily: 'Outfit',
                                                                    fontWeight: 500,
                                                                    fontSize: '16px',
                                                                    lineHeight: '100%',
                                                                    letterSpacing: "0px",
                                                                    mb: 1
                                                                }}>PO Date</Typography>
                                                                <TextField
                                                                    type="date"
                                                                    name="PoDate"
                                                                    value={filters.PoDate ? new Date(filters.PoDate).toISOString().split('T')[0] : ""}
                                                                    // onBlur={handleBlur}
                                                                    onChange={handleDateChange}
                                                                    onClick={(e) => {
                                                                        // Trigger the native date picker
                                                                        const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                                                                        if (input) input.showPicker?.();
                                                                    }}
                                                                    fullWidth
                                                                    sx={{
                                                                        // ...rightTextStyle,
                                                                        "& input::-webkit-calendar-picker-indicator": {
                                                                            display: "none",
                                                                            WebkitAppearance: "none",
                                                                        },
                                                                        "& input[type='date']": {
                                                                            appearance: "none",
                                                                            WebkitAppearance: "none",
                                                                        },
                                                                        "& .MuiOutlinedInput-root": {
                                                                            "& fieldset": {
                                                                                border: "none",
                                                                            },
                                                                        },
                                                                    }}
                                                                    InputProps={{
                                                                        startAdornment: (
                                                                            <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}

                                                                            >
                                                                                {calenderSVG}
                                                                            </Box>
                                                                        ),
                                                                        sx: {
                                                                            backgroundColor: "#E7E7EB",
                                                                            height: "40px",
                                                                            width: { xs: "100%", md: "100%" },
                                                                            borderRadius: "3px",
                                                                        },
                                                                    }}
                                                                />
                                                            </Grid>

                                                            <Grid size={12}>
                                                                <Box
                                                                    sx={{
                                                                        display: "flex",
                                                                        justifyContent: "flex-end",
                                                                        alignItems: "center",
                                                                    }}
                                                                >
                                                                    <Button onClick={handleReset}
                                                                        sx={{
                                                                            textTransform: "none",
                                                                            color: "#F15744",
                                                                            fontSize: "14px",
                                                                            lineHeight: "100%",
                                                                            fontFamily: "Outfit, sans-serif",
                                                                            borderRadius: "3px",
                                                                            fontWeight: 500,
                                                                            px: "20px",
                                                                            py: "15px",
                                                                        }}>
                                                                        Reset
                                                                    </Button>
                                                                    <Button
                                                                        type="button"
                                                                        onClick={handleApplyFilters}
                                                                        variant="contained"
                                                                        sx={{
                                                                            backgroundColor: "#00344C",
                                                                            borderRadius: "3px",
                                                                            textTransform: "none",
                                                                            fontWeight: 500,
                                                                            fontSize: "14px",
                                                                            lineHeight: "100%",
                                                                            fontFamily: "Outfit, sans-serif",
                                                                            color: "#FFFFFF",
                                                                            px: "20px",
                                                                            py: "15px",
                                                                        }}
                                                                    >
                                                                        Apply
                                                                    </Button>
                                                                </Box>
                                                            </Grid>
                                                        </Grid>
                                                    </Box>
                                                </ClickAwayListener>
                                            </Paper>
                                        </Grow>
                                    )}
                                </Popper>

                                <IconButton onClick={handleColumnOpen}>
                                    <ViewColumnIcon size={24} color="#48535B" />
                                </IconButton>

                                <IconButton onClick={handleExportExcel} disabled={isExporting}>
                                    <MdOutlineFileDownload size={24} color="#48535B" />
                                </IconButton>
                                <IconButton
                                    onClick={() => trigger(filters)}
                                >
                                    <LuRefreshCw size={20} color="#48535B" />
                                </IconButton>
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid size={12}>
                    <TableComponent
                        columns={tableColumns.filter(col => visibleColumns.includes(col.field))}
                        data={BoitemData?.data || []}
                        createSortHandler={handleRequestSort}
                        isLoading={isFetching}
                        order={sortOrder}
                        orderBy={sortBy}
                    />

                    <Menu
                        anchorEl={menuAnchorEl}
                        open={Boolean(menuAnchorEl)}
                        onClose={handleMenuClose}
                        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                        transformOrigin={{ vertical: "top", horizontal: "right" }}
                        PaperProps={{
                            elevation: 0,
                            sx: {
                                mt: 1,
                                borderRadius: "3px",
                                minWidth: 140,
                                border: "1px solid #E5E9EB",
                                boxShadow: "0px 10px 30px rgba(15, 23, 42, 0.12)",
                                overflow: "hidden",
                            },
                        }}
                        MenuListProps={{
                            sx: {
                                py: 0.5,
                            },
                        }}
                    >
                        {viewAccess &&
                            <MenuItem
                                onClick={handleMenuView}
                                sx={{
                                    fontFamily: "Outfit, sans-serif",
                                    fontSize: "14px",
                                    fontWeight: 400,
                                    px: 1.5,
                                    py: 1,
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                    color: "#111827",
                                    "&:hover": {
                                        backgroundColor: "#F6F8F9",
                                    },
                                }}
                            >
                                <LuEye size={16} style={{ color: "#4B5563" }} />
                                <span>View</span>
                            </MenuItem>
                        }

                        {editAccess &&
                            <MenuItem
                                onClick={handleMenuEdit}
                                sx={{
                                    fontFamily: "Outfit, sans-serif",
                                    fontSize: "14px",
                                    fontWeight: 400,
                                    px: 1.5,
                                    py: 1,
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                    color: "#111827",
                                    "&:hover": {
                                        backgroundColor: "#F6F8F9",
                                    },
                                }}
                            >
                                <EditIcon style={{ width: 14, height: 14 }} />
                                <span>Edit</span>
                            </MenuItem>
                        }
                        {deleteAccess && <MenuItem
                            onClick={handleDeleteProcurementTracker}
                            sx={{
                                fontFamily: "Outfit, sans-serif",
                                fontSize: "14px",
                                fontWeight: 400,
                                px: 1.5,
                                py: 1,
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                color: "#111827",
                                "&:hover": {
                                    backgroundColor: "#F6F8F9",
                                },
                            }}
                        >
                            <MdDeleteOutline style={{ width: 14, height: 14 }} />
                            <span>Delete</span>
                        </MenuItem>}

                    </Menu>

                    <CustomPagination
                        totalCount={BoitemData?.totalRecords || 0}
                        pageSize={pageSize}
                        page={pageNumber}
                        onPageChange={handlePageChange}
                        setCurrentPage={setPageNumber}
                        onPageSizeChange={handlePageSizeChange}
                    />
                </Grid>
            </Grid>
            {isEditTracker && <EditBoughtOutItems open={isEditTracker} handleClose={handleEditTracker} rowData={rowData} tabKey="boi" />}
            {isViewTracker && <ViewBoi open={isViewTracker} handleClose={handleViewClick} rowData={rowData} />}

        </>
    );
}

export default HotelBOIList;